/* eslint-disable */

const path = './sport-icons/';

export default {
    esports_call_of_duty: require(`${path}esports_call_of_duty.svg`).default,
    esports_call_of_duty_mobile: require(`${path}esports_call_of_duty_mobile.svg`)
        .default,
    esports_battlegrounds: require(`${path}esports_battlegrounds.svg`).default,
    esports_counter_strike: require(`${path}esports_counter_strike.svg`)
        .default,
    esports_dota_2: require(`${path}esports_dota_2.svg`).default,
    esports_fifa: require(`${path}esports_fifa.svg`).default,
    esports_halo: require(`${path}esports_halo.svg`).default,
    esports_hearthstone: require(`${path}esports_hearthstone.svg`).default,
    esports_heroes_of_the_storm: require(`${path}esports_heroes_of_the_storm.svg`)
        .default,
    esports_king_of_glory: require(`${path}esports_king_of_glory.svg`).default,
    esports_league_of_legends: require(`${path}esports_league_of_legends.svg`)
        .default,
    esports_nba_2k18: require(`${path}esports_nba_2k18.svg`).default,
    esports_overwatch: require(`${path}esports_overwatch.svg`).default,
    esports_rocket_league: require(`${path}esports_rocket_league.svg`).default,
    esports_starcraft_1: require(`${path}esports_starcraft_1.svg`).default,
    esports_starcraft: require(`${path}esports_starcraft.svg`).default,
    esports_vainglory: require(`${path}esports_vainglory.svg`).default,
    esports_warcraft_3: require(`${path}esports_warcraft_3.svg`).default,
    esports_world_of_tanks: require(`${path}esports_world_of_tanks.svg`)
        .default,
    esports_rainbow_six: require(`${path}esports_rainbow_six.svg`).default,
    esports_street_fighter_5: require(`${path}esports_street_fighter_5.svg`)
        .default,
    esports_fortnite: require(`${path}esports_fortnite.svg`).default,
    esports_artifact: require(`${path}esports_artifact.svg`).default,
    esports_smite: require(`${path}esports_smite.svg`).default,
    esports_apex_legends: require(`${path}esports_apex_legends.svg`).default,
    esports_dota_auto_chess: require(`${path}esports_dota_auto_chess.svg`)
        .default,
    esports_dota_underlords: require(`${path}esports_dota_underlords.svg`)
        .default,
    esports_crossfire: require(`${path}esports_crossfire.svg`).default,
    esports_valorant: require(`${path}esports_valorant.svg`).default,
    esports_tennis: require(`${path}esports_tennis.svg`).default,
    esports_racing: require(`${path}esports_racing.svg`).default,
    esports_mortal_kombat: require(`${path}esports_mortal_kombat.svg`).default,
    // NOTE: Next icons are copied from classic sports and should be replaced with proper svgs
    esports_basketball: require(`${path}esports_basketball.svg`).default,
    esports_ice_hockey: require(`${path}esports_ice_hockey.svg`).default,
    esports_boxing: require(`${path}esports_boxing.svg`).default,
    esports_formula_1: require(`${path}esports_formula_1.svg`).default,
    esports_volleyball: require(`${path}esports_volleyball.svg`).default,
    esports_specials: require(`${path}esports_specials.svg`).default,
    esports_call_of_duty_warzone: require(`${path}esports_call_of_duty_warzone.svg`)
        .default,
    esports_league_of_legends_wild_rift: require(`${path}esports_league_of_legends_wild_rift.svg`)
        .default,
    esports_world_of_warcraft: require(`${path}esports_world_of_warcraft.svg`)
        .default,
    esports_quake: require(`${path}esports_quake.svg`).default,
    esports_free_fire: require(`${path}esports_free_fire.svg`).default,
    esports_brawl_stars: require(`${path}esports_brawl_stars.svg`).default,
    esports_age_of_empires: require(`${path}esports_age_of_empires.svg`)
        .default,
    esports_clash_royale: require(`${path}esports_clash_royale.svg`).default,
    esports_mobile_legends_bang_bang: require(`${path}esports_mobile_legends_bang_bang.svg`)
        .default,
    esports_volta_football: require(`${path}esports_volta_football.svg`)
        .default,

    default: require(`${path}cybersport_default.svg`).default,
};
